import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-front',
  templateUrl: './front.component.html',
  styleUrls: ['./front.component.scss']
})
export class FrontComponent implements OnInit {

  constructor(public router: Router) { }

  ngOnInit() {
  }


  navtoCloudPage() {
    this.router.navigate(['/cloud-pbx']);
  }

  navToOnPremisePage() {
    this.router.navigate(['/on-premise']);
  }

}
